import React from 'react';
import BackgroundImageWithText from './BackgroundImageWithText';
import { templateHelper } from '../../../template/helpers/templateHelper';

export const backgroundWithImageHandler = {
    tags,
    elementEditor,
    defaultStyle,
    component,
    families
}

function component(element) {
    return <BackgroundImageWithText element={element} />
}

function tags() {
    return {
        startTag: '<!-- Background Image with Text : BEGIN -->',
        endTag: '<!-- Background Image with Text : END -->'
    }
}

function families() {
    return [
        'text'
    ]
}

function defaultStyle(templateStyle = null, defaultStyle = true, inherited = []) {
    const templateTextStyle = templateStyle ? templateStyle.text : null;
    const inheritedStyles = templateStyle && !defaultStyle ? [
        { templatePath: "text.color", stylePath: 'textStyle.color' },
        { templatePath: "text.fontSize", stylePath: 'textStyle.fontSize' },
    ] : [];
    return {
        wrapper: {
            backgroundColor: '#ffff'
        },
        elementProps: {
            source: 'https://via.placeholder.com/680x180',
            editor: null,
            width: '600',
            height: 'auto',
            altText: 'alt_text',
            border: '0',
            text: '<p>Maecenas sed ante pellentesque, posuere leo id, eleifend dolor. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Praesent laoreet malesuada cursus. Maecenas scelerisque congue eros eu posuere. Praesent in felis ut velit pretium lobortis rhoncus ut erat.</p>'
        },
        styleProps: {
            width: '100%',
            maxWidth: '680px',
        },
        textStyle: {
            padding: '20px',
            fontFamily: 'sans-serif',
            fontSize: templateTextStyle && !defaultStyle ? templateTextStyle.fontSize : '15px',
            lineHeight: 'normal',
            color: templateTextStyle && !defaultStyle ? templateTextStyle.color : '#555555',
        },
        className: 'g-img',
        inheritedStyles: inheritedStyles
    }
}
function elementEditor(elementStyle, templateStyle = null, defaultStyle = true) {
    //Take what is relevant from the template
    const templateTextStyle = templateStyle ? templateStyle.text : null;
    return (
        `<tr>
        <!-- Bulletproof Background Images c/o https://backgrounds.cm -->
        <td style="text-align: center; background-image: url(${elementStyle.elementProps.source}); background-color: #222222;   background-size: cover;background-repeat: no-repeat; background-position: center center !important; background-size: cover !important;">
            <!--[if gte mso 9]>
            <v:image xmlns:v="urn:schemas-microsoft-com:vml" fill="true" stroke="false" style="border: 0; display: inline-block; width: 680px; height: 180px;" src="${elementStyle.elementProps.source}" />
            <v:rect xmlns:v="urn:schemas-microsoft-com:vml" fill="true" stroke="false" style="border: 0; display: inline-block; position: absolute; width: 680px; height: 180px;">
            <v:fill opacity="0%" color="#222222" />
            <![endif]-->
            <div>
                <!--[if mso]>
                <table align="center" role="presentation" border="0" cellspacing="0" cellpadding="0" width="500">
                <tr>
                <td width="500">
                <![endif]-->
                <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:500px; margin: auto;">
                    <tbody><tr>
                        <td style="
                        text-align: center; 
                        padding: ${elementStyle.textStyle.padding}; 
                        font-family: ${elementStyle.textStyle.fontFamily}; 
                        font-size: ${templateTextStyle && !defaultStyle ? templateTextStyle.fontSize : elementStyle.textStyle.fontSize}; 
                        line-height: ${elementStyle.textStyle.lineHeight}; 
                        color: ${templateTextStyle && !defaultStyle ? templateHelper.convertRgbStringToHex(templateTextStyle.color) : templateHelper.convertRgbStringToHex(elementStyle.textStyle.color)};">
                            <p style="margin: 0;">${elementStyle.elementProps.text}</p>
                        </td>
                    </tr>
                </tbody></table>
                <!--[if mso]>
                </td>
                </tr>
                </table>
                <![endif]-->
            </div>
            <!--[if gte mso 9]>
            </v:fill>
            </v:rect>
            </v:image>
            <![endif]-->
        </td>
    </tr>`
    )
};


